import type { TDateTime } from '@/src/general/primitives/dates/date.types'

export const enum DONATION_SOURCE {
  AUTOMATIC = 'automatic',
  HEADER = 'header',
  MENU = 'menu',
  UNDEFINED = 'undefined',
}

export type TDonationData = {
  amounts: {
    recurrent: number[]
    oneTime: number[]
    /** Currency code (ex: EUR) */
    currency: string
    currencyCode: string
  }
  campaign: {
    key: string
    donorsGoal: number
    donorsPercentage: number
    endDate: TDateTime
    startDate: TDateTime
  } | null
  contactIds: number[] | null
  canAskForTaxReceipt: boolean
  isCampaignActive: boolean
  isRecurrentDonor: boolean
  link: {
    [key: string]: string // Filled by the API according to its needs: emailHash, utm_source, utm_campaign, utm_term...
  }
  notes: string | null
  prayingForHozanaFormUrl?: string | null
  showBanner: boolean
  signature: string | null
  text: string | null
  user: {
    siteSegment: number
    userQuintile: number
    lang: TLocale
    country: string
  } | null
}
